import gql from 'graphql-tag';

export class FormInput {
  id: number;
  name: string;
  isActive: boolean;
  matIds: string;

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.isActive = undefined;
    this.matIds = undefined;
  }
}

export const gqlGetQuery = gql`
  query getContainertypes($limit: Int, $offset: Int, $order: String, $where: String) {
    getContainertypes(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        isActive
        firstDate
        firstUser
        lastDate
        lastUser
        containertypesMaterials {
          id
          containertypeId
          materialId
          material {
            id
            name
          }
          isActive
        }
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getContainertypeById($id: Int) {
    getContainertypeById(id: $id) {
      id
      name
      isActive
      firstDate
      firstUser
      lastDate
      lastUser
      containertypesMaterials {
        id
        containertypeId
        materialId
        material {
          id
          name
        }
        isActive
        firstDate
        firstUser
        lastDate
        lastUser
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addContainertype($data: ContainertypeInput) {
    addContainertype(data: $data) {
      id
      name
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateContainertype($data: ContainertypeInput) {
    updateContainertype(data: $data) {
      id
      name
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteContainertype($id: Int) {
    deleteContainertype(id: $id)
  }
`;
